/**
 * For non abonned doctors, when unregestred user try to disply the doctor's phone number
 * Show a modal inviting the user to give his informations, so he can get the phone number
 */

import Cookies from 'js-cookie';
import HttpMethod from '../../app/enums/HttpMethod';
import Practitioner from '../../app/models/Practitioner';
import { isAuthenticated } from '../../app/support/functions';
import { initIntlInput, intlInstance, localizedRoute } from '../../app/support/helpers';
import { isValidEmail, allValidations, trans, isSubscribed, isMobileSize } from './functions';

$(document).ready(function() {

    var $modal                    = $('#userInfo');
    var $showPhoneButton          = $('.showPhone');
    var $sendUserInfoButton       = $('#sendUserInfo');
    var $cancelUserInfoButton = $('#cancelSendUserInfo');
    var validation                = allValidations();
	var intlTelInstance;

    //////////////////////////////////////////////////
    // SHOW PHONE NUMBER
    //////////////////////////////////////////////////

    $showPhoneButton.off().on('click', function(event) {
		event.preventDefault();

		var $element   = $(this);
        var hrefPhone  = $element.attr('href');

        if (hrefPhone && hrefPhone !== 'javascript:void(0)') {
            window.location.href = hrefPhone;
            return;
        }

        var {_doctor_id, _client_id, _action } = getDataAttributes();

        fetchPhoneNumber(_doctor_id);

        if (Cookies.get('user_info')) {
            var cookieInfo = JSON.parse(Cookies.get('user_info'));

            savePhoneSeeker({
                firstname: cookieInfo.firstname,
                lastname: cookieInfo.lastname,
                mobile: cookieInfo.mobile,
                dial_code: cookieInfo.dial_code,
                email: cookieInfo.email,
                doctor_id: _doctor_id,
                action: _action, // show:doctor:phone
            });
        } else if (!isNaN(_client_id)) {
            savePhoneSeeker({
                doctor_id: _doctor_id,
                action: _action, // show:doctor:phone
                client_id: _client_id,
            });
        } else {
            savePhoneSeeker({
                doctor_id: _doctor_id,
                action: _action, // show:doctor:phone
            });
        }
	});

    //////////////////////////////////////////////////
    // JOIN US
    //////////////////////////////////////////////////

    $('.joinUsButton').off().on('click', function(event) {
        event.preventDefault();
        initMobileInput();
        showModal();

        $cancelUserInfoButton.off('click').on('click', function(event) {
            event.preventDefault();
            hideModal();
        });

        $sendUserInfoButton.off('click').on('click', function(event) {
            event.preventDefault();
            validateForm();
        });
    });

    /*
    |--------------------------------------------------------------------------
    | Functions
    |--------------------------------------------------------------------------
    */

    /**
     * Fetch phone number
     *
     * @param {number} doctor_id
     */
    function fetchPhoneNumber(doctor_id) {
        $.ajax({
            url: localizedRoute('frontend.practitioners.info', doctor_id),
            type: HttpMethod.GET,
            dataType: 'json',
            beforeSend: function() {
                disableShowPhoneButton();
                showPhoneButtonLoader();
            }
        }).done(function(response) {
            const practitioner = Practitioner.new(response as {});
            insertPhoneNumber(practitioner.nationalPhoneNumber());
            itsTimeToShowJoinUsCard() && showJoinUsCard();
            isMobileSize() && scrollTop(300);
        })
        .always(function() {
            hidePhoneButtonLoader();
            enableShowPhoneButton();
        });
    }

    /**
     * Insert phone number in the DOM
     *
     * @param {number} phoneNumber
     * @returns {void}
     */
    function insertPhoneNumber(phoneNumber) {

        // @ts-ignore
        var phoneNumber = $.trim(phoneNumber);

        var hasPhone    = !!phoneNumber;

        var href        = 'tel:' + phoneNumber;

        var formatted   = phoneNumber.replace(/[^0-9]/g, "").replace(/\W/gi, '').replace(/(.{2})/g, '$1 ');

        var $span       = $showPhoneButton.find('.phoneNumber');

        $showPhoneButton.attr('href', hasPhone ? href : '');
        $span.text(hasPhone ? formatted : trans('not_available'));

        // show the phone number in modal itself

        // var $formPhoneNumber = $('.formPhoneNumber');
        // var $phoneNumberElm  = $formPhoneNumber.find('.phoneNumber');

        // $phoneNumberElm.attr('href', hasPhone ? href : '');
        // $phoneNumberElm.text(hasPhone ? formatted : trans('not_available'));
    }

    /**
     * Show phone number
     *
     * @returns {void}
     */
    function showPhoneNumber() {

        $modal.find('.description_modal').text('');
        $('.formPhoneNumber').show();
        $modal.find('form').hide();
    }

    /**
     * Check if it's time to show join us card
     *
     * @returns {boolean}
     */
    function itsTimeToShowJoinUsCard() {
        
        return !isAuthenticated() && $showPhoneButton.hasClass('showModal') && !Cookies.get('user_info');
    }

    /**
     * Hide join us card
     *
     * @returns {void}
     */
    function hideJoinUsCard() {
        // @ts-ignore
        document.querySelector('.joinUsCard').style.display = 'none';
    }

    /**
     * Show join us card
     *
     * @returns {void}
     */
    function showJoinUsCard() {
        // @ts-ignore
        document.querySelector('.joinUsCard').style.display = 'block';
    }

    /**
     * Hide modal
     *
     * @returns {void}
     */
    function hideModal() {
        $modal.modal('hide');
    }

    /**
     * Show modal
     *
     * @returns {void}
     */
    function showModal() {
        $modal.modal('show');
    }

    /**
     * Enable 'show phone number' button
     *
     * @returns {void}
     */
    function enableShowPhoneButton() {
        document.querySelector('.showPhone').classList.remove('pointer-events-none');
    }

    /**
     * Disable 'show phone number' button
     *
     * @returns {void}
     */
    function disableShowPhoneButton() {
        document.querySelector('.showPhone').classList.add('pointer-events-none');
    }

    /**
     * Show 'show phone number button' loader
     *
     * @returns {void}
     */
    function showPhoneButtonLoader() {
        document.querySelector('.showPhone .bar-loader').classList.remove('hidden');
    }

    /**
     * Hide 'show phone number button' loader
     *
     * @returns {void}
     */
    function hidePhoneButtonLoader() {
        document.querySelector('.showPhone .bar-loader').classList.add('hidden');
    }

    /**
     * Validate form
     *
     * @returns {boolean}
     */
    function validateForm() {

        var $firstname = $modal.find('#firstname');
        var $lastname  = $modal.find('#lastname');
        var $mobile    = $modal.find('#mobile');
        var $email     = $modal.find('#email');

        var $alert     = $modal.find('.alert-errors');

        var firstname  = $.trim($firstname.val() as string);
        var lastname   = $.trim($lastname.val() as string);
        var mobile     = $.trim($mobile.val() as string);
        var email      = $.trim($email.val() as string);

        var errors     = [];

        if (!firstname) {
            errors.push(validation.firstname.required);
            $firstname.addClass('input-error');
        } else {
            $firstname.removeClass('input-error');
        }

        if (!lastname) {
            errors.push(validation.lastname.required);
            $lastname.addClass('input-error');
        } else {
            $lastname.removeClass('input-error');
        }

        if (!mobile) {
            errors.push(validation.mobile.required);
            $mobile.addClass('input-error');
        } else {
            $mobile.removeClass('input-error');
        }

        if (mobile) {
            if (!isPhoneValid()) {
                errors.push(validation.mobile.invalid);
                $mobile.addClass('input-error');
            } else {
                $mobile.removeClass('input-error');
                $mobile.val(intlTelInstance.getNumber());
            }
        }

        // if (!email) {
        // 	errors.push(validation.email.required);
        // 	$email.addClass('input-error');
        // } else {
        // 	$email.removeClass('input-error');
        // }

        if (email) {
            if (!isValidEmail(email)) {
                errors.push(validation.email.invalid);
                $email.addClass('input-error');
            } else {
                $email.removeClass('input-error');
            }
        }

        if (errors.length) {
            $alert.html(' ');

            errors.forEach(function(element, index) {
                $alert.append('<p>' + element + '</p>');
            });

            $alert
                .prepend(
                    "<button data-dismiss='alert' class='close' type='button'>×</button>"
                )
                .show();

            $alert.show();

            $alert.off().on('click', function(event) {
                event.preventDefault();
                $(this).hide();
            });

        } else {

            $alert.hide();

            var { _doctor_id } = getDataAttributes();

            saveUserInfo({
                firstname: firstname,
                lastname: lastname,
                mobile: intlTelInstance.getNumber(),
                dial_code: intlTelInstance.getSelectedCountryData().dialCode,
                email: email,
                doctor_id: _doctor_id,
                action: 'signup'
            });
        }
    }

    /**
     * Save user info to database
     *
     * @param {*} user
     * @returns {void}
     */
    function savePhoneSeeker(user) {
        const phoneSeekerIsKnown = !!+user.firstname && !!+user.lastname && !!+user.mobile;
        $.ajax({
            url: localizedRoute('frontend.phone_request.store'),
            type: HttpMethod.POST,
            dataType: 'json',
            data: {
                firstname: user.firstname  !== undefined ? user.firstname : '',
                lastname : user.lastname   !== undefined ? user.lastname : '',
                mobile   : user.mobile     !== undefined ? user.mobile : '',
                dial_code: user.dial_code  !== undefined ? user.dial_code : '',
                email    : user.email      !== undefined ? user.email : '',
                doctor_id: user.doctor_id  !== undefined ? user.doctor_id : null,
                action   : user.action     !== undefined ? user.action : null,
                client_id: user.client_id  !== undefined ? user.client_id : false,
            }
        }).done(function (data) {
            phoneSeekerIsKnown && Cookies.set('user_info', JSON.stringify(data), { expires: 3650 });
        });
    };

    /**
     * Save user info to database
     *
     * @param {*} user
     * @returns {void}
     */
    function saveUserInfo(user) {

        $.ajax({
            url: localizedRoute('frontend.phone_request.store'),
            type: HttpMethod.POST,
            dataType: 'json',
            data: {
                firstname: user.firstname,
                lastname: user.lastname,
                mobile: user.mobile,
                dial_code: user.dial_code,
                email: user.email,
                doctor_id: user.doctor_id,
                action: user.action,
                client_id: user.client_id !== undefined ? user.client_id : false,
            },
            beforeSend: function () {
                showModalLoader();
                disableModalButtons();
            }
        }).done(function (data) {
            Cookies.set('user_info', JSON.stringify(data), { expires: 3650 });
            showFeedBack();
            hideModal();
            isMobileSize() && scrollTop(300);
        }).always(function () {
            hideModalLoader();
            enableModalButtons();
        });
    };

    function showFeedBack() {
        setJoinUsTitle(trans('thank_you'));
        setJoinUsBody(trans('we_will_contact_you_soon'));
        adjustJoinUsCardHeight();
        removeJoinUsButton();
    }

    /**
     * Set join us title
     *
     * @param {string} text
     * @returns {void}
     */
    function setJoinUsTitle(text) {
        document.querySelector('.joinUsTitle').innerHTML = text;
    }

    /**
     * Set join us title
     *
     * @param {string} text
     * @returns {void}
     */
    function setJoinUsBody(text) {
        document.querySelector('.joinUsBody').innerHTML = text;
    }

    /**
     * Adjust join us card height
     *
     * @returns {void}
     */
    function adjustJoinUsCardHeight() {
        // @ts-ignore
        document.querySelector('.joinUsCard').style.height = '134px';
    }

    /**
     * Remove join us button
     *
     * @returns {void}
     */
    function removeJoinUsButton() {
        document.querySelector('.joinUsButtonWrapper').remove();
    }

    /**
     * Show modal loader
     *
     * @returns {void}
     */
    function showModalLoader() {
        $modal.find('.bar-loader').removeClass('hidden');
    }

    /**
     * Hide modal loader
     *
     * @returns {void}
     */
    function hideModalLoader() {
        $modal.find('.bar-loader').addClass('hidden');
    }

    /**
     * Disable "modal buttons"
     *
     * @returns {void}
     */
    function disableModalButtons() {
        disableSendUserInfoButton();
        disableCancelUserInfoButton();
    }

    /**
     * Enable "modal buttons"
     *
     * @returns {void}
     */
    function enableModalButtons() {
        enableSendUserInfoButton();
        enableCancelUserInfoButton();
    }

    /**
     * Disable 'send user info' button
     *
     * @returns {void}
     */
    function disableSendUserInfoButton() {
        $sendUserInfoButton.prop('disabled', true);
    }

    /**
     * Enable 'send user info' button
     *
     * @returns {void}
     */
    function enableSendUserInfoButton() {
        $sendUserInfoButton.prop('disabled', false);
    }

    /**
     * Disable 'cancel user info' button
     *
     * @returns {void}
     */
    function disableCancelUserInfoButton() {
        $cancelUserInfoButton.prop('disabled', true);
    }

    /**
     * Enable 'cancel user info' button
     *
     * @returns {void}
     */
    function enableCancelUserInfoButton() {
        $cancelUserInfoButton.prop('disabled', false);
    }

    /**
     * Init mobile number input
     *
     * @returns {void}
     */
    function initMobileInput() {
        if (intlTelInstance) return;
        const mobile = $modal.find('#mobile').get(0);
        initIntlInput(mobile);
        intlTelInstance = intlInstance(mobile);
    }

    /**
     * Click to show browser's "call this number" action
     *
     * @returns {void}
     */
    function clickToShowCallAction() {
        $showPhoneButton.find('.phoneNumber').click();
    }

    /**
     * Check if phone number is valid
     *
     * @returns {void}
     */
    function isPhoneValid() {
        return intlTelInstance.isValidNumber();
    }

    /**
     * Show ad modal
     *
     * @returns {void}
     */
    function showAdModal() {

        if (isSubscribed()) {
            return; // No ads for subscribed doctors
        }

        var timeleft = 5;

        var downloadTimer = setInterval(function () {
            if (timeleft <= 0) {
                clearInterval(downloadTimer);
                $("#modal-header").html('<button id="countdown" type="button" class="btn btn-default" data-dismiss="modal">' + trans('show_number') + '</button>');
            } else {
                $("#modal-header").html('<span id="countdown" >' + timeleft + '</span>');
            }
            timeleft -= 1;
        }, 1000);

        $('#ads-modal').modal({
            backdrop: 'static',
            keyboard: false
        });
    };

    /**
     * Get data attributes
     *
     * @returns {void}
     */
    function getDataAttributes() {
        return {
            _doctor_id: parseInt($showPhoneButton.data('doctorId')),
            _client_id: parseInt($showPhoneButton.data('clientId')),
            _action: $showPhoneButton.data('action'),
        };
    }

    /**
     * Scroll to top
     *
     * @param {number} scrollTop
     * @param {string} speed
     */
    function scrollTop(scrollTop = 300, speed = 'slow') {
        $("html, body").animate({ scrollTop: scrollTop }, speed);
    }
});


